import { firstError } from '@/utils/errors';
import { datasetPermissions } from '../../sharing/constants';
import { datasourceIngestEnabled } from '../../datasource/helper';
import { dictionariesHaveChanged } from '../../dictionaries/helper';

class AttachmentsPolicy {
  constructor({ permissions }, dataset) {
    this.permissions = permissions;
    this.dataset = dataset;

    this.storageEnabled = this.dataset.status.storage_enabled.supported;
    this.storageError = firstError(this.dataset.attachments.readErrors);
    this.allowAttach = !!this.dataset.permissions[datasetPermissions.ATTACH];
    this.allowIngest = !!this.dataset.permissions[datasetPermissions.INGEST_DATA];
    this.allowManage = !!this.dataset.permissions[datasetPermissions.ATTACHMENTS];
    this.canCreate = permissions.attachments.create && (this.allowManage || this.allowAttach);
    this.canDelete = permissions.datasets.update
    && permissions.attachments.destroy ? this.allowManage || this.allowAttach : false;
    this.canDownload = permissions.attachments.download ? this.allowManage || this.allowAttach : false;
    this.canManage = permissions.datasets.update && permissions.attachments.create && this.allowManage;
    this.canRead = !dataset.isNew && permissions.attachments.read;
    this.canUpdate = permissions.attachments.update && this.allowManage;
    this.canUpload = (dataset.isEditing && !dataset.steps.wizardOn) || dataset.isNew ? false : this.canCreate;
  }

  canConvert(datasourceFeatures) {
    return (
      !dictionariesHaveChanged(this.dataset)
      && datasourceIngestEnabled(datasourceFeatures)
      && this.permissions.attachments.ingest
    )
      ? this.allowManage || this.allowIngest
      : false;
  }
}

export default AttachmentsPolicy;
